import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=27ecd288&scoped=true"
import script from "./BuildInfo.vue?vue&type=script&lang=js"
export * from "./BuildInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecd288",
  null
  
)

export default component.exports